module.exports = __webpack_public_path__ + "static/media/logo_hdbank.074e31ca.svg";